<template>
    <div class="d-flex">
    <div class="refresh-information text-nowrap">
        <i class="fas fa-chart-line mr-2 fa-lg"></i>
        <span v-if="!$breakpoint.smAndDown"> Market Change (PPL) </span>
        <span class="pl-3 heading-medium"> {{ Math.abs(getMarketChange) | priceformat }}</span>
        <div class="market-change">
            <i class="fas fa-caret-up" v-if="getMarketChange > 0"></i>
            <i class="fas fa-caret-down" v-else-if="getMarketChange < 0"></i>
        </div>
    </div>
    <div class="refresh-information ml-2 text-nowrap">
        <i class="fas fa-sync-alt mr-2 fa-lg" :class="{'fa-spin': getRefreshSecondsLeft < 1}"></i>
        <span v-if="getRefreshSecondsLeft < 1" class="pl-2 pr-2">Updating...</span>
        <span v-else-if="!$breakpoint.smAndDown" class="pl-2 pr-2">Refresh Information</span>
        <span class="pl-2 heading-medium">{{getRefreshSecondsLeft | countdownformat}}s</span>
    </div>
    </div>
</template>

<script>
import breakpoint from '@/mixins/index';
import { mapGetters } from 'vuex';

export default {
    mixins: [breakpoint],
    computed: {
        ...mapGetters("livePrices", ["getMarketChange", 'getRefreshSecondsLeft']),
    }
}
</script>
<style lang="scss" scoped>
@import "@/assets/scss/components/_refresh-information.scss";

.market-change {
    .fas {
        font-size: 1.5rem;
        margin-left: 0.5rem;
        
        &.fa-caret-up {
            color: map-get($theme-colors, primary);
        }

        &.fa-caret-down {
            color: map-get($theme-colors, danger);
        }
    }
}
</style>